// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
import ContactFilterController from "./contact_filter_controller"
application.register("contact-filter", ContactFilterController)
import ContactMapController from "./contact_map_controller"
application.register("contact-map", ContactMapController)
import LocationFieldsController from "./location_fields_controller"
application.register("location-fields", LocationFieldsController)
import RsvpButtonController from "./rsvp_button_controller"
application.register("rsvp-button", RsvpButtonController)
